/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.anthropic.integration.rpc.AppSettingsRpc
 */

export const installRpc = {
  serviceName: 'com.hubspot.anthropic.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'Y9TUur42H_xef3Jhxa0zqIzwybuKcMMr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const uninstallRpc = {
  serviceName: 'com.hubspot.anthropic.integration.rpc.AppSettingsRpc',
  rpcName: 'uninstall',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABef3Jhxa0zqIzwybuKcMMr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const upsertApiKeyRpc = {
  serviceName: 'com.hubspot.anthropic.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: 'bVgwIzXuX0kSuYkk3Cx4IYzwybuKcMMr',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};